import { isKey } from '../../utils/index'
import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  root: {
    base: {
      backgroundColor: theme.colors.backgrounds.content,
      border: theme.settings.borders.regular,
      borderRadius: theme.settings.borderRadiuses.regular,
      overflow: 'hidden',
      display: 'inline-flex',
      flexDirection: 'column',
      textAlign: 'center',
      width: '40px',
      height: '40px',
    },
  },

  head: {
    base: {
      textTransform: 'uppercase',
      fontSize: '9px',
      lineHeight: '15px',
      borderBottom: theme.settings.borders.regular,
    },

    range: {
      fontSize: '6px',
    },

    ...['default', 'cta', 'primary', 'secondary', 'positive', 'negative', 'alert', 'brand', 'white'].reduce(
      (acc, variant) =>
        Object.assign(acc, {
          [variant]: {
            backgroundColor: isKey(theme.colors.accents, variant) && theme.colors.accents[variant],
            color: variant === 'white' ? theme.colors.text.normal : theme.colors.text.light,
          },
        }),
      {}
    ),

    dim: {
      backgroundColor: theme.colors.backgrounds.gray,
      color: theme.colors.text.dimmed,
    },
  },

  body: {
    base: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '13px',
      fontWeight: 'bold',
    },

    range: {
      fontSize: '12px',
    },

    dim: {
      color: theme.colors.text.dimmed,
    },
  },
})
